import { computed } from 'mobx';

export default class UserPreferenceModel {
  id;
  store;

  constructor(store, user) {
    this.store = store;
    this.updateFromJson(user);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      timezone: this.timezone,
      station_redirect: this.station_redirect,
      common_station_search: this.common_station_search,
      status_time: this.status_time,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.timezone = json.timezone;
    this.station_redirect = json.station_redirect;
    this.common_station_search = json.common_station_search;
    this.status_time = json.status_time;
  }
}



// WEBPACK FOOTER //
// ./src/models/UserPreferenceModel.js